/* ymm.js */
/* ==========================================================
   Year / Make / Model data for the promo popup.
   Years: 2026 back to 1996 (the range the 5610 supports).
   Models cover the major US/Canada market makes; any make
   without a list (or an unlisted model) falls back to the
   "Not listed here" option that the popup appends automatically.
   ========================================================== */
window.YMM = {
  makes: [
    "Acura","Alfa Romeo","Audi","BMW","Buick","Cadillac","Chevrolet","Chrysler","Dodge","Fiat",
    "Ford","Genesis","GMC","Honda","Hummer","Hyundai","Infiniti","Isuzu","Jaguar","Jeep","Kia",
    "Land Rover","Lexus","Lincoln","Maserati","Mazda","Mercedes-Benz","Mercury","Mini","Mitsubishi",
    "Nissan","Oldsmobile","Plymouth","Pontiac","Porsche","Ram","Saab","Saturn","Scion","Subaru",
    "Suzuki","Tesla","Toyota","Volkswagen","Volvo"
  ],
  models: {
    "Acura": ["ILX","TLX","TL","TSX","RLX","RL","MDX","RDX","ZDX","Integra","NSX","CL","Legend"],
    "Alfa Romeo": ["Giulia","Stelvio","4C","Giulietta","Tonale"],
    "Audi": ["A3","A4","A4 allroad","A5","A6","A7","A8","Q3","Q5","Q7","Q8","e-tron","TT","R8","S3","S4","S5","RS 5","allroad"],
    "BMW": ["2 Series","3 Series","4 Series","5 Series","6 Series","7 Series","8 Series","X1","X2","X3","X4","X5","X6","X7","Z4","i3","i4","iX","M3","M4","M5"],
    "Buick": ["Enclave","Encore","Encore GX","Envision","LaCrosse","Regal","Verano","Lucerne","Century","LeSabre","Rendezvous","Cascada","Rainier"],
    "Cadillac": ["ATS","CTS","CT4","CT5","CT6","XTS","XT4","XT5","XT6","Escalade","SRX","DTS","STS","DeVille","Eldorado","Lyriq"],
    "Chevrolet": ["Silverado 1500","Silverado 2500HD","Colorado","Camaro","Corvette","Malibu","Impala","Cruze","Sonic","Spark","Equinox","Traverse","Tahoe","Suburban","Blazer","Trax","Trailblazer","Bolt EV","Volt","Cobalt","Aveo","HHR","Express","Avalanche","S-10","Monte Carlo"],
    "Chrysler": ["300","200","Pacifica","Town & Country","Sebring","PT Cruiser","Voyager","Aspen","Crossfire","Concorde"],
    "Dodge": ["Charger","Challenger","Durango","Journey","Grand Caravan","Dart","Avenger","Caliber","Nitro","Magnum","Neon","Stratus","Intrepid","Dakota","Viper"],
    "Fiat": ["500","500L","500X","124 Spider"],
    "Ford": ["F-150","F-250 Super Duty","F-350 Super Duty","Ranger","Maverick","Mustang","Explorer","Escape","Edge","Expedition","Bronco","Bronco Sport","Focus","Fusion","Fiesta","Taurus","Escort","Flex","EcoSport","Transit","Transit Connect","Crown Victoria","Five Hundred","Freestyle","Freestar","Windstar"],
    "Genesis": ["G70","G80","G90","GV60","GV70","GV80"],
    "GMC": ["Sierra 1500","Sierra 2500HD","Canyon","Yukon","Yukon XL","Acadia","Terrain","Savana","Envoy","Jimmy","Sonoma","Hummer EV"],
    "Honda": ["Accord","Civic","CR-V","Pilot","Odyssey","HR-V","Ridgeline","Passport","Fit","Insight","Element","CR-Z","Crosstour","S2000","Prelude","Accord Crosstour"],
    "Hummer": ["H1","H2","H3","H3T"],
    "Hyundai": ["Elantra","Sonata","Accent","Tucson","Santa Fe","Kona","Palisade","Veloster","Genesis","Azera","Ioniq","Ioniq 5","Venue","Santa Cruz","Nexo","Tiburon","Entourage","Equus","Veracruz","Santa Fe Sport"],
    "Infiniti": ["Q50","Q60","Q70","QX50","QX55","QX60","QX70","QX80","G35","G37","FX35","FX45","M35","M45","EX35","JX35","I30","QX4","QX56"],
    "Isuzu": ["Rodeo","Trooper","Ascender","i-Series","Axiom","Amigo","VehiCROSS"],
    "Jaguar": ["XE","XF","XJ","F-Type","F-Pace","E-Pace","I-Pace","S-Type","X-Type","XK"],
    "Jeep": ["Wrangler","Grand Cherokee","Cherokee","Compass","Renegade","Gladiator","Patriot","Liberty","Commander","Wagoneer","Grand Wagoneer","Grand Cherokee L"],
    "Kia": ["Optima","Forte","Rio","Soul","Sportage","Sorento","Telluride","Seltos","Stinger","Sedona","Carnival","Niro","K5","Cadenza","Spectra","Amanti","Sephia","Borrego","Rondo"],
    "Land Rover": ["Range Rover","Range Rover Sport","Range Rover Evoque","Range Rover Velar","Discovery","Discovery Sport","Defender","LR2","LR3","LR4","Freelander"],
    "Lexus": ["ES","IS","GS","LS","RC","LC","NX","RX","GX","LX","UX","CT","HS","SC","RZ","IS F"],
    "Lincoln": ["MKZ","MKS","MKX","MKC","MKT","Continental","Navigator","Aviator","Corsair","Nautilus","Town Car","LS","Zephyr","Mark LT"],
    "Maserati": ["Ghibli","Quattroporte","Levante","GranTurismo","GranCabrio","Grecale","Coupe"],
    "Mazda": ["Mazda3","Mazda6","CX-3","CX-30","CX-5","CX-9","CX-50","CX-90","MX-5 Miata","Mazda2","Tribute","CX-7","RX-8","Protege","Millenia","MPV","B-Series","MX-30"],
    "Mercedes-Benz": ["A-Class","C-Class","E-Class","S-Class","CLA","CLS","GLA","GLB","GLC","GLE","GLS","G-Class","SL","SLC","SLK","CLK","ML-Class","GL-Class","GLK-Class","Metris","Sprinter","EQS","EQE"],
    "Mercury": ["Grand Marquis","Milan","Sable","Mariner","Mountaineer","Montego","Cougar","Villager","Marauder"],
    "Mini": ["Cooper","Cooper Clubman","Cooper Countryman","Paceman","Convertible","Hardtop"],
    "Mitsubishi": ["Outlander","Outlander Sport","Eclipse Cross","Mirage","Lancer","Eclipse","Galant","Endeavor","Montero","Montero Sport","Raider","Diamante","Mirage G4"],
    "Nissan": ["Altima","Sentra","Maxima","Versa","Rogue","Rogue Sport","Murano","Pathfinder","Armada","Frontier","Titan","Kicks","Juke","Leaf","370Z","350Z","GT-R","Cube","Quest","Xterra","Ariya","Z","NV200"],
    "Oldsmobile": ["Alero","Aurora","Intrigue","Bravada","Silhouette","Cutlass","Eighty-Eight","Achieva","Regency"],
    "Plymouth": ["Neon","Breeze","Voyager","Prowler","Grand Voyager"],
    "Pontiac": ["Grand Prix","Grand Am","G6","G8","G5","G3","Vibe","Bonneville","Firebird","GTO","Solstice","Torrent","Aztek","Montana","Sunfire","Trans Sport"],
    "Porsche": ["911","718 Cayman","718 Boxster","Cayenne","Macan","Panamera","Taycan","Boxster","Cayman"],
    "Ram": ["1500","2500","3500","ProMaster","ProMaster City","Dakota"],
    "Saab": ["9-3","9-5","9-7X","9-2X","900"],
    "Saturn": ["Ion","Aura","Vue","Outlook","Sky","Relay","L-Series","S-Series"],
    "Scion": ["tC","xB","xD","xA","FR-S","iA","iM","iQ"],
    "Subaru": ["Outback","Forester","Crosstrek","Impreza","Legacy","Ascent","WRX","BRZ","Baja","Tribeca","Solterra","SVX"],
    "Suzuki": ["Grand Vitara","SX4","Kizashi","Forenza","Aerio","XL-7","Reno","Verona","Equator","Vitara","Esteem"],
    "Tesla": ["Model 3","Model S","Model X","Model Y","Roadster","Cybertruck"],
    "Toyota": ["Camry","Corolla","Prius","RAV4","Highlander","4Runner","Tacoma","Tundra","Sienna","Sequoia","Avalon","Yaris","C-HR","Venza","Land Cruiser","Supra","86","GR86","GR Corolla","Matrix","Solara","FJ Cruiser","Echo","bZ4X","Corolla Cross","Prius Prime"],
    "Volkswagen": ["Jetta","Passat","Golf","GTI","Golf R","Tiguan","Atlas","Atlas Cross Sport","Beetle","Arteon","Taos","ID.4","Touareg","CC","Eos","Rabbit","Routan","GLI"],
    "Volvo": ["S60","S90","V60","V90","XC40","XC60","XC90","S40","S80","V50","V70","C30","C70","XC70"]
  }
};


/* script-sd35.js */
/* ==========================================================
   INNOVA SD35 landing page (index-sd35.html)
   Built on Oct 14, 2026 from the switch page's script, with everything that belongs to the 5610 offer
   taken out (the free gifts, the holiday picker, the flash sale sheet, the scratch-card popup and the
   InnovaCare+ add-on) and a block added for the features section. It shares no file with the 5610 pages.
   ========================================================== */
(function () {
  'use strict';

  /* ---------- the offer, again, between the guarantee and the FAQ ----------
     #buyBottom is empty in the page: a copy of the offer at the top goes in first thing, before anything
     else is wired up, so every handler below (gallery, fit check, accordions, stock, delivery date, buy
     buttons, photo viewer) finds both offers. The copy's ids, and the aria-controls that point at them, get
     a "-b" suffix so nothing is duplicated. The offer has nothing to pick, so a copy at load stays true. */
  (function () {
    var src = document.querySelector('#buy > .wrap'), slot = document.getElementById('buyBottom');
    if (!src || !slot) return;
    var copy = src.cloneNode(true);
    [].forEach.call(copy.querySelectorAll('[id]'), function (el) { el.id = el.id + '-b'; });
    [].forEach.call(copy.querySelectorAll('[aria-controls]'), function (el) { el.setAttribute('aria-controls', el.getAttribute('aria-controls') + '-b'); });
    slot.appendChild(copy);
  })();

  /* ---------- star ratings ---------- */
  var STAR = 'M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5 7.3 14.03 2.6 9.45l6.5-.95z';
  document.querySelectorAll('[data-stars]').forEach(function (el) {
    var v = parseFloat(el.getAttribute('data-stars')) || 5, html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = v >= i ? 1 : (v > i - 1 ? v - (i - 1) : 0);
      if (fill === 1) {
        html += '<svg viewBox="0 0 24 24"><path d="' + STAR + '"/></svg>';
      } else if (fill === 0) {
        html += '<svg viewBox="0 0 24 24" style="fill:#d5d9df"><path d="' + STAR + '"/></svg>';
      } else {
        var id = 'g' + Math.random().toString(36).slice(2, 8);
        html += '<svg viewBox="0 0 24 24"><defs><linearGradient id="' + id + '">' +
          '<stop offset="' + (fill * 100) + '%" stop-color="currentColor"/>' +
          '<stop offset="' + (fill * 100) + '%" stop-color="#d5d9df"/></linearGradient></defs>' +
          '<path d="' + STAR + '" fill="url(#' + id + ')"/></svg>';
      }
    }
    el.innerHTML = html;
    el.style.color = '#f5a524';
  });

  /* ---------- reviews carousel ---------- */
  var rstage = document.getElementById('rstage');
  var rdots = document.getElementById('rdots');
  if (rstage && rdots) {
    var rslides = rstage.querySelectorAll('.rslide');
    var dots = rdots.querySelectorAll('i');
    var show = function (n) {
      rslides.forEach(function (s, i) { s.classList.toggle('on', i === n); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === n); });
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
  }

  /* ---------- product gallery thumbnails (each offer's gallery on its own) ---------- */
  document.querySelectorAll('.buy .gal').forEach(function (gal) {
    var main = gal.querySelector('.main img'), btns = gal.querySelectorAll('.thumbs button');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        if (main) { main.src = b.getAttribute('data-src'); if (b.getAttribute('data-alt')) main.alt = b.getAttribute('data-alt'); }
      });
    });
  });

  /* ---------- "does it work on my car?" fit checker ----------
     There are three on the page: under each offer's buy button and in the 5,000+ section. Each works on its
     own. The SD35 covers OBD2 cars, 1996 and newer (it has no OBD1 coverage), so the years stop at 1996. */
  (function () {
    if (!window.YMM) return;
    // keep the promise honest: leave out the EV-only brand, EVs, and heavy-duty / commercial models
    var EX_MAKES = { 'Tesla': 1 };
    var EX_MODELS = {};
    ['e-tron', 'i3', 'i4', 'iX', 'Bolt EV', 'Lyriq', 'Ioniq 5', 'Nexo', 'I-Pace', 'EQS', 'EQE', 'Leaf',
     'Ariya', 'Taycan', 'Solterra', 'bZ4X', 'ID.4', 'RZ', 'GV60', 'Hummer EV', 'H1',
     'F-250 Super Duty', 'F-350 Super Duty', 'Silverado 2500HD', 'Sierra 2500HD', '2500', '3500',
     'ProMaster', 'ProMaster City', 'Express', 'Savana', 'Sprinter', 'Transit', 'Transit Connect',
     'Metris', 'NV200'].forEach(function (m) { EX_MODELS[m] = 1; });
    var HEADERS = ['Nice choice!', "That's a nice ride.", 'Great taste!', 'Solid pick.', 'Ooh, good one.'];
    var headIdx = 0;
    var opt = function (sel, label, value) {
      var o = document.createElement('option');
      o.textContent = label; o.value = (value === undefined ? label : value);
      sel.appendChild(o); return o;
    };

    document.querySelectorAll('.fitcheck').forEach(function (box) {
      var toggle = box.querySelector('.fit-toggle'), panel = box.querySelector('.fit-panel');
      var yearSel = box.querySelector('.fit-year'), makeSel = box.querySelector('.fit-make'), modelSel = box.querySelector('.fit-model');
      var result = box.querySelector('.fit-result'), resultHead = box.querySelector('.fit-result b'), resultText = box.querySelector('.fit-result-text');
      if (!toggle || !panel || !yearSel || !makeSel || !modelSel || !result) return;

      yearSel.innerHTML = '<option value="" selected disabled>Year</option>';
      var soon = opt(yearSel, '2026 (Coming soon)', ''); soon.disabled = true;
      for (var y = 2025; y >= 1996; y--) opt(yearSel, String(y));

      var fillMakes = function () {
        var cur = makeSel.value;
        makeSel.innerHTML = '<option value="" selected disabled>Make</option>';
        window.YMM.makes.forEach(function (m) { if (!EX_MAKES[m]) opt(makeSel, m); });
        if (cur) { makeSel.value = cur; if (makeSel.value !== cur) makeSel.selectedIndex = 0; }
      };
      var fillModels = function () {
        var cur = modelSel.value;
        modelSel.innerHTML = '<option value="" selected disabled>Model</option>';
        (window.YMM.models[makeSel.value] || []).forEach(function (m) { if (!EX_MODELS[m]) opt(modelSel, m); });
        modelSel.disabled = !makeSel.value;
        if (cur) { modelSel.value = cur; if (modelSel.value !== cur) modelSel.selectedIndex = 0; }
      };
      var showResult = function () {
        if (yearSel.value && makeSel.value && modelSel.value) {
          resultHead.textContent = HEADERS[headIdx % HEADERS.length]; headIdx++;
          resultText.textContent = 'The Innova SD35 works with your ' + yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value + '.';
          result.hidden = false;
        } else {
          result.hidden = true;
        }
      };
      yearSel.addEventListener('change', function () { fillMakes(); fillModels(); showResult(); });
      makeSel.addEventListener('change', function () { fillModels(); showResult(); });
      modelSel.addEventListener('change', showResult);
      toggle.addEventListener('click', function () {
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) yearSel.focus();
      });
      // clean state on load / bfcache restore (don't let the browser keep a stale result showing)
      var reset = function () {
        yearSel.selectedIndex = 0;
        fillMakes(); makeSel.selectedIndex = 0;
        modelSel.innerHTML = '<option value="" selected disabled>Model</option>'; modelSel.disabled = true;
        result.hidden = true;
        panel.hidden = true; toggle.setAttribute('aria-expanded', 'false');
      };
      reset();
      window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
    });
  })();

  /* ---------- accordions (both offers' panels + FAQ) ---------- */
  function accordion(root) {
    if (!root) return;
    root.querySelectorAll('.it').forEach(function (item) {
      var q = item.querySelector('.q'), a = item.querySelector('.a');
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.it.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.a').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  document.querySelectorAll('.buy .acc').forEach(accordion);
  accordion(document.getElementById('faq'));

  /* ---------- countdown ---------- */
  var timer = document.getElementById('timer');
  if (timer) {
    var KEY = 'innova_sd35_deadline', deadline = 0, now = Date.now();
    try { deadline = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
    if (!deadline || deadline < now || deadline - now > 7 * 3600 * 1000) {
      deadline = now + 5 * 3600 * 1000 + 2 * 60 * 1000 + 45 * 1000;
      try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var d = Math.max(0, deadline - Date.now());
      timer.textContent = Math.floor(d / 3600000) + ':' +
        pad(Math.floor((d % 3600000) / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- the supported features window ---------- */
  function wireModal(modal, openBtns) {
    if (!modal) return;
    var open = function () {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
    };
    var close = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open') && !document.querySelector('.lbx.open')) document.body.classList.remove('modal-lock');
    };
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  }
  wireModal(document.getElementById('featModal'), document.querySelectorAll('.js-feat-open'));

  /* ---------- customer videos: play while on screen, tap to unmute (one at a time) ---------- */
  (function () {
    var figs = [].slice.call(document.querySelectorAll('.infl'));
    if (!figs.length) return;
    figs.forEach(function (fig) {
      var vid = fig.querySelector('video');
      var btn = fig.querySelector('.infl-sound');
      if (!vid) return;
      var toggle = function (e) {
        if (e) e.preventDefault();
        var turnOn = vid.muted;
        figs.forEach(function (f) {
          var v = f.querySelector('video');
          if (v) v.muted = true;
          f.classList.remove('on');
        });
        if (turnOn) {
          vid.muted = false;
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
          fig.classList.add('on');
        }
      };
      if (btn) btn.addEventListener('click', toggle);
      vid.addEventListener('click', toggle);
    });
  })();

  /* videos marked data-inview play only while they are on screen, so the four customer clips and the speed
     test don't download behind the offer on the first screen */
  (function () {
    var vids = [].slice.call(document.querySelectorAll('video[data-inview]'));
    if (!vids.length) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) { if (!still) vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !still) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------- scarcity: live stock counter (both offers show the same figure) ---------- */
  var stockLeft = document.querySelectorAll('.js-stock-left');
  var scarFill = document.querySelectorAll('.js-scar-fill');
  if (stockLeft.length && scarFill.length) {
    var pct = 4; // % of the deal left
    var render = function () {
      stockLeft.forEach(function (el) { el.textContent = pct + '%'; });
      scarFill.forEach(function (el) { el.style.width = pct + '%'; });
    };
    render();
    setInterval(function () {
      if (pct > 2 && Math.random() < 0.55) {
        pct = Math.max(2, Math.round((pct - (Math.random() * 0.3 + 0.1)) * 10) / 10);
        render();
      }
    }, 8000);
  }

  /* ---------- delivery date: 2 days ahead (PST) ---------- */
  try {
    var future = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', weekday: 'long', month: 'long', day: 'numeric'
    }).format(new Date(Date.now() + 2 * 86400000));
    document.querySelectorAll('.js-delivery').forEach(function (el) { el.textContent = future; });
  } catch (e) { /* leave fallback text */ }

  /* ---------- checkout: slide-in cart, then the pre-filled cart link ----------
     The SD35 (41133961773102), the $10 "FREE Shipping" item (41968968794158) and the $99 "RS2 App Access"
     item (41990063915054, the one the 5610 partnerships pages add; the user's request, Oct 14, 2026).
     The code is the SD35 page's own, SD35_PARTNERSHIPS_FP, made by the user on Oct 14, 2026 as a Buy X get Y
     discount: buy the SD35, get RS2 App Access and FREE Shipping free. Checked at innova.com checkout the same
     day: app -$99, shipping -$10, SD35 $149.99, subtotal $149.99; and with no SD35 in the cart it frees nothing.
     (The store's SD35_BOGO frees the shipping item only, and for a few hours this page used the 5610 pages'
     5610_PARTNERSHIPS_FP, which frees both but counts the orders with the 5610 partnerships ones.) */
  var CART_CODE = 'SD35_PARTNERSHIPS_FP';
  var CART_URL = 'https://www.innova.com/cart/41133961773102:1,41968968794158:1,41990063915054:1?discount=' + CART_CODE;
  var cartGo = document.getElementById('cartGo');
  /* Other apps can add their own parameters to our cart links after the page loads: Intelligems
     appends attributes[igId]=... so the order is credited to the visitor's test group. Carry over
     anything that isn't ours (discount, payment) from the link being replaced. */
  var keepExtras = function (oldHref, url) {
    var q = (oldHref && oldHref.indexOf('/cart/') > -1 && oldHref.split('?')[1]) || '';
    var extras = q.split('&').filter(function (p) { return p && !/^(discount|payment)=/i.test(p); });
    return extras.length ? url + (url.indexOf('?') < 0 ? '?' : '&') + extras.join('&') : url;
  };
  var setCheckout = function (url) {
    document.querySelectorAll('.js-checkout').forEach(function (a) { if (a.tagName === 'A') a.setAttribute('href', keepExtras(a.getAttribute('href'), url)); });
    if (cartGo) cartGo.setAttribute('href', keepExtras(cartGo.getAttribute('href'), url));
  };
  setCheckout(CART_URL);

  /* ---------- Shop Pay Installments window: check out with the whole order ----------
     Shopify's "Continue to checkout" button builds /cart/<SD35 variant>:1 by itself, so the free shipping
     item and the code would drop off. Catch the click before Shopify's own handler runs and send it to
     the same cart link the rest of the page uses. The window lives in an open shadow root, which
     composedPath() can see into. If Shopify ever renames the hook, nothing matches and theirs runs. */
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var hit = path.some(function (n) {
      return n && n.getAttribute && n.getAttribute('data-testid') === 'sample-plans-modal-continue-to-checkout-button';
    });
    if (!hit || !cartGo) return;
    var url = cartGo.getAttribute('href');
    if (!url || url === '#') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + 'payment=shop_pay_installments';
  }, true);

  /* ---------- announcement-bar phrase: swap the lead on holiday weekends (Pacific) ----------
     Only the words before the colon change (e.g. "SPECIAL OFFER" -> "LABOR DAY SALE"): #barLead, the everyday
     lead. From Nov 6 to Dec 31, 2026 the holiday season (the script at the top of index-sd35.html) hides it and
     shows its own lead for each step, so a weekend name set here stays out of sight then. */
  (function () {
    var barMsgEl = document.getElementById('barLead');
    if (!barMsgEl) return;
    var addDays = function (d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); };
    var nthWeekday = function (y, m, wd, n) { var d = new Date(y, m, 1); var s = (wd - d.getDay() + 7) % 7; return new Date(y, m, 1 + s + (n - 1) * 7); };
    var lastWeekday = function (y, m, wd) { var d = new Date(y, m + 1, 0); var s = (d.getDay() - wd + 7) % 7; return addDays(d, -s); };
    var windowsFor = function (Y) {
      var tg = nthWeekday(Y, 10, 4, 4); // Thanksgiving = 4th Thursday of November
      return [
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 0, 1),   end: new Date(Y, 0, 1) },
        { lead: "PRESIDENTS' DAY SALE", start: addDays(nthWeekday(Y, 1, 1, 3), -3), end: nthWeekday(Y, 1, 1, 3) },
        { lead: 'MEMORIAL DAY SALE',    start: addDays(lastWeekday(Y, 4, 1), -3), end: lastWeekday(Y, 4, 1) },
        { lead: '4TH OF JULY SALE',     start: new Date(Y, 6, 1),   end: new Date(Y, 6, 5) },
        { lead: 'LABOR DAY SALE',       start: addDays(nthWeekday(Y, 8, 1, 1), -3), end: nthWeekday(Y, 8, 1, 1) },
        { lead: 'BLACK FRIDAY SALE',    start: tg,                  end: addDays(tg, 3) },
        { lead: 'CYBER MONDAY SALE',    start: addDays(tg, 4),      end: addDays(tg, 4) },
        { lead: 'CHRISTMAS SALE',       start: new Date(Y, 11, 10), end: new Date(Y, 11, 25) },
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 11, 26), end: new Date(Y, 11, 31) }
      ];
    };
    var pac;
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { g[x.type] = x.value; });
      pac = new Date(parseInt(g.year, 10), parseInt(g.month, 10) - 1, parseInt(g.day, 10));
    } catch (e) { pac = new Date(); }
    var W = windowsFor(pac.getFullYear()), t = pac.getTime(), lead = null;
    for (var i = 0; i < W.length; i++) { if (t >= W[i].start.getTime() && t <= W[i].end.getTime()) { lead = W[i].lead; break; } }
    if (lead) barMsgEl.textContent = lead;
  })();

  /* ---------- slide-in cart: offer buttons open it; every other button scrolls to the offer ---------- */
  var cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    /* 5-minute "cart reserved" countdown: starts on first open, persists across opens */
    var cartTimerEl = document.getElementById('cartTimer');
    var cartEnd = 0, cartInt = null, pad2 = function (n) { return String(n).padStart(2, '0'); };
    var renderCartTimer = function () {
      if (!cartTimerEl) return;
      var d = Math.max(0, cartEnd - Date.now());
      cartTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000));
      if (d <= 0 && cartInt) { clearInterval(cartInt); cartInt = null; }
    };
    var startCartTimer = function () {
      var now = Date.now();
      if (!cartEnd || cartEnd - now <= 0) cartEnd = now + 5 * 60 * 1000;
      renderCartTimer();
      if (!cartInt) cartInt = setInterval(renderCartTimer, 1000);
    };
    var openCart = function () {
      cartDrawer.classList.add('open');       // display:block
      void cartDrawer.offsetWidth;            // reflow so the transition runs from the off-screen state
      cartDrawer.classList.add('show');       // slide in + fade overlay
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      startCartTimer();
    };
    var closeCart = function () {
      cartDrawer.classList.remove('show');
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      setTimeout(function () { if (!cartDrawer.classList.contains('show')) cartDrawer.classList.remove('open'); }, 440);
    };
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart();
    });

    /* Fire a CTA-click event into whatever analytics the store has (Meta Pixel, GA4, GTM dataLayer).
       product: 'SD35' tells these clicks apart from the 5610 pages' (same event name). No-op on Railway. */
    var trackCTA = function (el) {
      var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var where = el.closest('#buy') ? 'offer'
                : el.closest('#buyBottom') ? 'offer-bottom'
                : el.closest('.bar') ? 'announcement'
                : el.closest('#features') ? 'features'
                : el.closest('.final') ? 'final'
                : el.closest('.modal') ? 'modal' : 'other';
      var data = { button_text: label, location: where, product: 'SD35' };
      try { if (window.fbq) fbq('trackCustom', 'ClaimOfferClick', data); } catch (e) {}
      try { if (window.gtag) gtag('event', 'claim_offer_click', data); } catch (e) {}
      try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'claim_offer_click', button_text: label, location: where, product: 'SD35' }); } catch (e) {}
    };
    /* The same rule as the switch page (the user, Oct 14, 2026: "use the same logic we've been using for the
       other pages"). The buttons in either offer open the cart, and so does the last section's (data-cart),
       which has only the FAQ between it and the repeated offer. Any other button opens the cart while either
       offer's buy button is on screen (a scroll would go nowhere), and otherwise takes the visitor to
       whichever offer is nearer, so they see the price and what is included before the cart. */
    var onScreen = function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    };
    var buyOnScreen = function () { return [].some.call(document.querySelectorAll('.buy-first .claim-first'), onScreen); };
    var scrollToBuy = function () {
      var buy = document.getElementById('buy'), again = document.getElementById('buyBottom');
      // the repeated offer lands by its content (its .wrap, scroll-margin in style-sd35.css), so the price and the
      // buy button sit where the top offer's do when the page opens, inside the first screen on a phone
      if (buy && again && again.firstElementChild && Math.abs(again.getBoundingClientRect().top) < Math.abs(buy.getBoundingClientRect().top)) buy = again.firstElementChild;
      // scrollIntoView scrolls whatever the real container is (window.scrollTo no-ops on Shopify, where the
      // theme makes <body> the scroller). The bar offset is CSS scroll-margin-top.
      if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    document.querySelectorAll('.js-checkout').forEach(function (el) {
      var inOffer = !!el.closest('#buy, #buyBottom');      // the repeated offer was copied in before this ran
      el.addEventListener('click', function (e) {
        e.preventDefault();
        trackCTA(el);
        if (inOffer || el.hasAttribute('data-cart') || buyOnScreen()) openCart();
        else scrollToBuy();
      });
    });
  }

  /* ---------- anchor scrolling ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- come back to this tab: alert the title + favicon when the visitor leaves ---------- */
  (function () {
    var origTitle = document.title;
    var favEl = document.querySelector('link[rel~="icon"]');
    if (!favEl) { favEl = document.createElement('link'); favEl.rel = 'icon'; document.head.appendChild(favEl); }
    // On Shopify the section's <link rel="icon"> renders inside <body>, where browsers ignore it: move it to <head>
    else if (!favEl.closest('head')) { document.head.appendChild(favEl); }
    var origHref = favEl.getAttribute('href');
    var badgedHref = null;
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 32; c.height = 32;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, 32, 32);
        ctx.beginPath(); ctx.arc(23, 9, 8, 0, 2 * Math.PI);
        ctx.fillStyle = '#da291c'; ctx.fill();
        ctx.lineWidth = 2.5; ctx.strokeStyle = '#fff'; ctx.stroke();
        badgedHref = c.toDataURL('image/png');
      } catch (e) { /* canvas blocked, the title alert still works */ }
    };
    if (origHref) img.src = origHref;
    var ALERTS = ['🔴 Your deal is waiting', '👋 Come back for $50 OFF'];
    var flip = null, i = 0;
    var setFav = function (h) { if (h) favEl.setAttribute('href', h); };
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        setFav(badgedHref);
        i = 0; document.title = ALERTS[0];
        if (!flip) flip = setInterval(function () {
          i = (i + 1) % (ALERTS.length + 1);
          document.title = i === 0 ? origTitle : ALERTS[i - 1];
        }, 1400);
      } else {
        if (flip) { clearInterval(flip); flip = null; }
        document.title = origTitle;
        setFav(origHref);
      }
    });
  })();

  /* ==========================================================================
     FEATURES, ONE AT A TIME (#features)
     The list of names lights the panel on screen and scrolls to a panel when clicked; on a phone the
     row of chips also slides the lit chip into view. Each panel gets .is-in while it is on screen, which
     runs its picture's animation (CSS), and three pictures are driven from here: the live graph's lines,
     the voltmeter and the speed test video.
     ========================================================================== */
  (function () {
    var sec = document.getElementById('features');
    if (!sec) return;
    var links = [].slice.call(sec.querySelectorAll('.fx-link'));
    var panels = [].slice.call(sec.querySelectorAll('.fx-panel'));
    var navList = sec.querySelector('.fx-nav-list');
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = '';

    var light = function (id) {
      if (id === current) return;
      current = id;
      links.forEach(function (l) {
        var on = l.getAttribute('data-fx') === id;
        l.classList.toggle('on', on);
        if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
        // phone: the chips scroll sideways; bring the lit one into view without moving the page
        if (on && navList && navList.scrollWidth > navList.clientWidth + 4) {
          var left = l.offsetLeft - navList.offsetLeft, right = left + l.offsetWidth;
          if (left < navList.scrollLeft + 8 || right > navList.scrollLeft + navList.clientWidth - 8) {
            var to = Math.max(0, left - 16);
            if (navList.scrollTo) navList.scrollTo({ left: to, behavior: still ? 'auto' : 'smooth' }); else navList.scrollLeft = to;
          }
        }
      });
    };
    links.forEach(function (l) {
      l.addEventListener('click', function () {
        var p = document.getElementById(l.getAttribute('data-fx'));
        if (p && p.scrollIntoView) p.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
        light(l.getAttribute('data-fx'));
      });
    });

    if ('IntersectionObserver' in window) {
      // the panel crossing a line just under the middle of the screen is the one the list lights
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) light(en.target.id); });
      }, { rootMargin: '-45% 0px -54% 0px', threshold: 0 });
      panels.forEach(function (p) { spy.observe(p); });
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle('is-in', en.isIntersecting);
          en.target.dispatchEvent(new CustomEvent(en.isIntersecting ? 'fx:in' : 'fx:out'));
        });
      }, { threshold: 0.2 });
      panels.forEach(function (p) { seen.observe(p); });
    } else {
      panels.forEach(function (p) { p.classList.add('is-in'); });
    }

    /* 03: three readings on the instrument grid. Each line repeats every 600 units, so the strip of 1200
       scrolling left by 600 (CSS) loops without a seam. Shapes only: an illustration, not the SD35's screen. */
    (function () {
      var lines = sec.querySelector('.fx-lines');
      if (!lines) return;
      var TAU = Math.PI * 2, P = 600;
      var bump = function (x, at, w) { var dx = ((x - at) % P + P) % P; if (dx > P / 2) dx -= P; return Math.exp(-(dx * dx) / (2 * w * w)); };
      var shapes = {
        g1: function (x) { return 112 - 34 * bump(x, 150, 34) - 46 * bump(x, 420, 26) - 10 * Math.sin(TAU * x / P * 3) - 4 * Math.sin(TAU * x / P * 11 + 1); },   // RPM: two revs
        g2: function (x) { return 150 - 9 * Math.sin(TAU * x / P + 0.6) - 3 * Math.sin(TAU * x / P * 4); },                                                        // coolant: slow and steady
        g3: function (x) { return 206 + 12 * bump(x, 150, 30) + 15 * bump(x, 420, 22) - 2.5 * Math.sin(TAU * x / P * 13); }                                         // battery: dips as it revs
      };
      Object.keys(shapes).forEach(function (k) {
        var path = lines.querySelector('.' + k), f = shapes[k], d = '';
        for (var x = 0; x <= 1200; x += 6) d += (x ? ' L' : 'M') + x + ' ' + f(x).toFixed(1);
        if (path) path.setAttribute('d', d);
      });
    })();

    /* 06: the voltmeter steps through battery, cranking and charging while its panel is on screen.
       The readings are an illustration of the three tests, not a measurement. */
    (function () {
      var panel = document.getElementById('fx6');
      if (!panel) return;
      var svg = panel.querySelector('.fx-gauge-svg'), needle = panel.querySelector('.gz-needle'), arc = panel.querySelector('.gz-val');
      var out = document.getElementById('gzVal'), tabs = [].slice.call(panel.querySelectorAll('.fx-gauge-steps span'));
      var ticks = panel.querySelector('.gz-ticks');
      var LO = 8, HI = 16, NS = 'http://www.w3.org/2000/svg';
      var STEPS = [{ v: 12.6 }, { v: 10.2 }, { v: 14.2 }];          // battery, cranking, charging
      var ang = function (v) { return -90 + (v - LO) / (HI - LO) * 180; };
      if (ticks) {
        for (var v = LO; v <= HI; v++) {
          var a = ang(v) * Math.PI / 180, major = v % 2 === 0;
          var r1 = major ? 64 : 69, r2 = 75;
          var ln = document.createElementNS(NS, 'line');
          ln.setAttribute('x1', (120 + r1 * Math.sin(a)).toFixed(1)); ln.setAttribute('y1', (130 - r1 * Math.cos(a)).toFixed(1));
          ln.setAttribute('x2', (120 + r2 * Math.sin(a)).toFixed(1)); ln.setAttribute('y2', (130 - r2 * Math.cos(a)).toFixed(1));
          ticks.appendChild(ln);
          if (major) {
            var tx = document.createElementNS(NS, 'text');
            tx.setAttribute('x', (120 + 53 * Math.sin(a)).toFixed(1)); tx.setAttribute('y', (133 - 53 * Math.cos(a)).toFixed(1));
            tx.setAttribute('text-anchor', 'middle'); tx.textContent = v;
            ticks.appendChild(tx);
          }
        }
      }
      var at = 0, shown = 12.6, timer = 0, raf = 0;
      var count = function (to) {
        cancelAnimationFrame(raf);
        if (still || !window.requestAnimationFrame) { shown = to; if (out) out.textContent = to.toFixed(1); return; }
        var from = shown, t0 = 0;
        var step = function (t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
          shown = from + (to - from) * e;
          if (out) out.textContent = shown.toFixed(1);
          if (k < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      };
      var set = function (i) {
        at = i;
        var v = STEPS[i].v;
        if (needle) needle.style.transform = 'rotate(' + ang(v).toFixed(2) + 'deg)';
        if (arc) arc.style.strokeDashoffset = (100 - (v - LO) / (HI - LO) * 100).toFixed(2);
        tabs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
        count(v);
      };
      var run = function () { clearInterval(timer); if (!still) timer = setInterval(function () { set((at + 1) % STEPS.length); }, 2600); };
      panel.addEventListener('fx:in', function () { set(at); run(); });
      panel.addEventListener('fx:out', function () { clearInterval(timer); });
      if (svg) set(0);
    })();

    /* 09: the speed test video plays only while its panel is on screen */
    (function () {
      var panel = document.getElementById('fx9'), v = panel && panel.querySelector('video');
      if (!v) return;
      panel.addEventListener('fx:in', function () { if (!still) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
      panel.addEventListener('fx:out', function () { if (!v.paused) v.pause(); });
    })();
  })();

  /* ---------- photo viewer: the offer's photos full size, with zoom ----------
     A click (or tap) on the photo, or on the button in its corner, opens it at the photo on show. The
     arrows, the thumbnails, a swipe or the arrow keys move between photos; Esc, the x or a click beside
     the photo closes it. A click on the photo zooms in at that spot: then the mouse looks around by
     moving (a finger by dragging), and another click zooms back out. The zoom goes as far as the photo's
     own pixels allow, between 2x and 3x. */
  (function () {
    var box = document.getElementById('lightbox'), frames = document.querySelectorAll('.buy .gal .main');
    if (!box || !frames.length) return;
    var stage = document.getElementById('lbxStage'), img = document.getElementById('lbxImg');
    var count = document.getElementById('lbxCount'), hint = document.getElementById('lbxHint'), strip = document.getElementById('lbxThumbs');
    var srcs = [].map.call(document.querySelectorAll('#galThumbs button'), function (b) { return b.getAttribute('data-src'); });
    if (!srcs.length) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var words = { idle: touch ? 'Tap to zoom, swipe for more' : 'Click to zoom',
                  zoomed: touch ? 'Drag to look around, tap to zoom out' : 'Move to look around, click to zoom out' };
    var at = 0, zoomed = false, Z = 2, ox = 0.5, oy = 0.5, lastFocus = null, down = null, skipUntil = 0;
    var clamp = function (v) { return isFinite(v) ? Math.max(0, Math.min(1, v)) : 0.5; };
    var origin = function (x, y) { ox = x; oy = y; img.style.transformOrigin = (x * 100).toFixed(2) + '% ' + (y * 100).toFixed(2) + '%'; };
    var zoom = function (on, x, y) {
      if (on && !img.offsetWidth) return;             // the photo is still loading
      zoomed = on;
      box.classList.toggle('zoomed', on);
      if (on) {
        Z = Math.min(3, Math.max(2, (img.naturalWidth || 1000) / img.offsetWidth));
        origin(x, y);
        img.style.transform = 'scale(' + Z.toFixed(3) + ')';
      } else img.style.transform = '';
      hint.textContent = on ? words.zoomed : words.idle;
    };
    var show = function (n) {
      at = (n + srcs.length) % srcs.length;
      zoom(false);
      var want = srcs[at], next = new Image();
      next.onload = next.onerror = function () { if (srcs[at] === want) img.src = want; };
      next.src = want;
      img.alt = 'Innova SD35, photo ' + (at + 1) + ' of ' + srcs.length;
      count.textContent = (at + 1) + ' / ' + srcs.length;
      [].forEach.call(strip.children, function (b, k) { b.classList.toggle('on', k === at); });
      [at + 1, at - 1].forEach(function (k) { var p = new Image(); p.src = srcs[(k + srcs.length) % srcs.length]; });
    };
    srcs.forEach(function (src, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (n + 1));
      // the gallery's own small thumbnail, loaded only when the viewer first opens
      var small = document.querySelectorAll('#galThumbs button img')[n];
      var t = document.createElement('img'); t.loading = 'lazy'; t.src = small ? small.getAttribute('src') : src; t.alt = '';
      b.appendChild(t);
      b.addEventListener('click', function () { show(n); });
      strip.appendChild(b);
    });
    var open = function (main) {                      // main: the photo clicked, in either offer
      var n = srcs.indexOf(main.getAttribute('src'));
      lastFocus = document.activeElement;
      box.classList.add('open');
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      show(n < 0 ? 0 : n);
      box.querySelector('.lbx-x').focus();
    };
    var close = function () {
      box.classList.remove('open');
      box.setAttribute('aria-hidden', 'true');
      zoom(false);
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    frames.forEach(function (frame) {
      frame.addEventListener('click', function () { open(frame.querySelector('img')); });
    });
    box.querySelectorAll('[data-lbx-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.getElementById('lbxPrev').addEventListener('click', function () { show(at - 1); });
    document.getElementById('lbxNext').addEventListener('click', function () { show(at + 1); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(at + 1);
      else if (e.key === 'ArrowLeft') show(at - 1);
    });
    // the page behind must not scroll while the viewer is open
    box.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
    box.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    stage.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, ox: ox, oy: oy, type: e.pointerType, moved: false };
    });
    stage.addEventListener('pointermove', function (e) {
      if (zoomed && e.pointerType === 'mouse') {      // a mouse looks around just by moving
        var sr = stage.getBoundingClientRect();
        origin(clamp((e.clientX - sr.left - img.offsetLeft) / img.offsetWidth), clamp((e.clientY - sr.top - img.offsetTop) / img.offsetHeight));
        return;
      }
      if (!down || down.type === 'mouse') return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) down.moved = true;
      if (zoomed) origin(clamp(down.ox - dx / ((Z - 1) * img.offsetWidth)), clamp(down.oy - dy / ((Z - 1) * img.offsetHeight)));
    });
    stage.addEventListener('pointerup', function (e) {
      var d = down; down = null;
      if (!d || d.type === 'mouse') return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(at + (dx < 0 ? 1 : -1));   // a swipe
      if (d.moved || Math.abs(dx) + Math.abs(dy) > 8) skipUntil = Date.now() + 300;   // a click right after is part of the gesture
    });
    stage.addEventListener('pointercancel', function () { down = null; });
    stage.addEventListener('click', function (e) {
      if (Date.now() < skipUntil) return;
      if (e.target !== img) { close(); return; }      // beside the photo
      if (zoomed) { zoom(false); return; }
      var r = img.getBoundingClientRect();
      zoom(true, clamp((e.clientX - r.left) / r.width), clamp((e.clientY - r.top) / r.height));
    });
    hint.textContent = words.idle;
  })();
})();


/* ==========================================================================
   3D WIREFRAME SPORTS CAR
   Hand-rolled: model-space vertices, Y-rotation, X-tilt, perspective divide, painter-ordered edges.
   No libraries. Two instances share one model:
     .wire  #truckWire      "sweep"   - a scan plane travels the length
     .wire  #truckWireFeat  "systems" - each subsystem lights in turn
   Both pause off-screen and go static under prefers-reduced-motion. On this light page the lines are
   the SD35's blue and a lit edge turns Innova red (the --wire* colours in style-sd35.css).
   ========================================================================== */
(function () {
  'use strict';
  var a = document.getElementById('truckWire');
  var b = document.getElementById('truckWireFeat');
  if (!a && !b) return;

  var V = [], E = [];
  function vtx(x, y, z) { V.push([x, y, z]); return V.length - 1; }
  function edge(p, q, w, kind) { E.push([p, q, w === undefined ? 1 : w, kind || '']); }

  var BODY = 38, CABIN = 26, SILL = 6;
  var WHEEL_R = 15, WHEEL_Y = 15, ARCH_R = 18, FRONT_X = -62, REAR_X = 60;
  function arch(wx) {
    var pts = [];
    for (var d = -30; d <= 210; d += 30) {
      var r = d * Math.PI / 180;
      pts.push([wx + Math.cos(r) * ARCH_R, WHEEL_Y + Math.sin(r) * ARCH_R, BODY, 0]);
    }
    return pts;
  }
  /* [x, y, half-width, cross-member?] traced nose -> roof -> tail, then back along the underside */
  var PROFILE = [
    [-100, 12, 30, 1], [-97, 19, 33, 1], [-80, 27, 36, 0], [-62, 37, BODY, 0],
    [ -38, 35, 33, 1],
    [  -8, 50, CABIN, 1], [14, 51, CABIN, 1],
    [  48, 39, 33, 1], [60, 40, BODY, 0], [86, 39, 36, 0],
    [  93, 42, 35, 1], [100, 36, 33, 0], [100, 22, 33, 1],
    [  96,  8, 34, 0], [88, SILL, 36, 0]
  ].concat(arch(REAR_X), arch(FRONT_X), [[-92, SILL, 34, 0], [-98, 8, 31, 0]]);

  var Lp = [], Rp = [];
  PROFILE.forEach(function (p) { Lp.push(vtx(p[0], p[1], -p[2])); Rp.push(vtx(p[0], p[1], p[2])); });
  for (var i = 0; i < PROFILE.length; i++) {
    var nx = (i + 1) % PROFILE.length;
    edge(Lp[i], Lp[nx]); edge(Rp[i], Rp[nx]);
    if (PROFILE[i][3]) edge(Lp[i], Rp[i], .5);
  }
  edge(Lp[4], Lp[7], .45); edge(Rp[4], Rp[7], .45);

  [-1, 1].forEach(function (sd) {
    function side(x, y, hw) { return vtx(x, y, sd * hw); }
    edge(side(-98, 15, 29), side(-84, 21, 35), .7);
  });

  function ring(cx, cy, r, z, seg, w) {
    var first = -1, prev = -1;
    for (var k = 0; k < seg; k++) {
      var ang = k / seg * Math.PI * 2;
      var id = vtx(cx + Math.cos(ang) * r, cy + Math.sin(ang) * r, z);
      if (k === 0) first = id; else edge(prev, id, w, 'wheel');
      prev = id;
    }
    edge(prev, first, w, 'wheel');
  }
  [-1, 1].forEach(function (sd) {
    [FRONT_X, REAR_X].forEach(function (wx) {
      var z = sd * (BODY + 2);
      ring(wx, WHEEL_Y, WHEEL_R, z, 18, 1);
      ring(wx, WHEEL_Y, 10.5, z, 14, .55);
      for (var sp = 0; sp < 5; sp++) {
        var a5 = sp / 5 * Math.PI * 2 - Math.PI / 2;
        edge(vtx(wx + Math.cos(a5) * 3, WHEEL_Y + Math.sin(a5) * 3, z),
             vtx(wx + Math.cos(a5) * 10.5, WHEEL_Y + Math.sin(a5) * 10.5, z), 0.35, 'wheel');
      }
    });
  });

  E.forEach(function (e) {
    if (e[3] === 'wheel') { e[4] = 'brakes'; return; }
    var p = V[e[0]], q = V[e[1]];
    var my = (p[1] + q[1]) / 2, mx = (p[0] + q[0]) / 2;
    e[4] = (my > 34 && mx > -40 && mx < 52) ? 'airbags' : (mx < -30 ? 'engine' : 'transmission');
  });

  var GRID = [];
  for (var gx = -150; gx <= 150; gx += 30) GRID.push([[gx, 0, -95], [gx, 0, 95]]);
  for (var gz = -95; gz <= 95; gz += 30) GRID.push([[-150, 0, gz], [150, 0, gz]]);

  var SYSTEMS = [
    { k: 'engine',       label: 'Engine & emissions' },
    { k: 'brakes',       label: 'ABS brakes' },
    { k: 'airbags',      label: 'SRS airbags' },
    { k: 'transmission', label: 'Transmission' }
  ];

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function rgbVar(name, fallback) {
    var m = null;
    try { m = getComputedStyle(document.body).getPropertyValue(name).match(/^\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*$/); } catch (e) {}
    return m ? [+m[1], +m[2], +m[3]] : fallback;
  }
  var C_LINE = rgbVar('--wire', [31, 111, 216]).join(','), C_HOT = rgbVar('--wire-hot', [225, 27, 12]).join(',');
  var C_GLOW = rgbVar('--wire-glow', [225, 27, 12]).join(','), C_GRID = rgbVar('--wire-grid', [70, 82, 100]).join(',');

  function mount(cv, opts) {
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1, TILT = 0.18;
    var labelEl = opts.labelEl || null, shownSys = -1;

    function resize() {
      var r = cv.getBoundingClientRect();
      if (!r.width) return false;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return true;
    }
    function project(p, cosY, sinY, scale, cx, cy) {
      var x = p[0] * cosY - p[2] * sinY;
      var z = p[0] * sinY + p[2] * cosY;
      var y = p[1] - 26;
      var ct = Math.cos(TILT), st = Math.sin(TILT);
      var y2 = y * ct - z * st;
      var z2 = y * st + z * ct;
      var d = 460 / (460 + z2);
      return [cx + x * d * scale, cy - y2 * d * scale, z2];
    }
    function frame(t) {
      if (!W && !resize()) return;
      var rot = reduce ? 0.45 : 0.42 + Math.sin(t / 6500) * 0.45;
      var cosY = Math.cos(rot), sinY = Math.sin(rot);
      var scale = Math.min(W / 240, H / 96);
      var cx = W / 2, cy = H / 2 + H * 0.07;

      var sysIdx = -1, sysMix = 0;
      if (opts.mode === 'systems') {
        var per = 2700;
        sysIdx = reduce ? 0 : Math.floor(t / per) % SYSTEMS.length;
        var phase = reduce ? 0.5 : (t % per) / per;
        sysMix = Math.min(1, Math.min(phase, 1 - phase) * 6);
        if (labelEl && sysIdx !== shownSys) { labelEl.textContent = SYSTEMS[sysIdx].label; shownSys = sysIdx; }
      }
      var sweep = (opts.mode === 'systems' || reduce) ? 1e9 : (((t / 2600) % 1) * 300 - 150);

      ctx.clearRect(0, 0, W, H);
      ctx.lineWidth = 1;
      GRID.forEach(function (g) {
        var p = project(g[0], cosY, sinY, scale, cx, cy);
        var q = project(g[1], cosY, sinY, scale, cx, cy);
        var al = Math.max(0, 0.16 - ((p[2] + q[2]) / 2) / 2400);
        if (al <= 0.005) return;
        ctx.strokeStyle = 'rgba(' + C_GRID + ',' + al.toFixed(3) + ')';
        ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(q[0], q[1]); ctx.stroke();
      });

      var pts = V.map(function (p) { return project(p, cosY, sinY, scale, cx, cy); });
      var order = E.map(function (e, idx) { return [idx, (pts[e[0]][2] + pts[e[1]][2]) / 2]; })
                   .sort(function (m, n) { return n[1] - m[1]; });
      order.forEach(function (o) {
        var e = E[o[0]], p = pts[e[0]], q = pts[e[1]], depth = o[1];
        var fade = Math.max(0.2, Math.min(1, 1 - (depth + 60) / 230));
        var near;
        if (opts.mode === 'systems') {
          near = (e[4] === SYSTEMS[sysIdx].k) ? sysMix : 0;
        } else {
          var mx = (V[e[0]][0] + V[e[1]][0]) / 2;
          near = Math.max(0, 1 - Math.abs(mx - sweep) / 34);
        }
        ctx.lineWidth = (e[2] * 1.4 + near * 1.1);
        if (near > 0.02) {
          // on a light ground a lit edge goes red with a soft red glow (no whitening, which would vanish)
          ctx.shadowBlur = 10 * near;
          ctx.shadowColor = 'rgba(' + C_GLOW + ',' + (0.45 * near).toFixed(3) + ')';
          ctx.strokeStyle = 'rgba(' + C_HOT + ',' + (fade * (0.6 + 0.4 * near)).toFixed(3) + ')';
        } else {
          ctx.shadowBlur = 0;
          var dim = opts.mode === 'systems' ? 0.5 : 0.85;
          ctx.strokeStyle = 'rgba(' + C_LINE + ',' + (fade * dim).toFixed(3) + ')';
        }
        ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(q[0], q[1]); ctx.stroke();
      });
      ctx.shadowBlur = 0;
    }

    var running = false, raf = 0;
    function tick(t) { frame(t); raf = requestAnimationFrame(tick); }
    function start() {
      if (running) return;
      running = true;
      try { frame(performance.now()); } catch (err) {}
      raf = requestAnimationFrame(tick);
    }
    function stop() { if (running) { running = false; cancelAnimationFrame(raf); } }
    window.addEventListener('resize', function () { W = 0; });
    resize(); frame(0);
    if (reduce) return;
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { x.isIntersecting ? start() : stop(); });
      }, { threshold: 0.01 }).observe(cv);
    } else { start(); }
  }

  mount(a, { mode: 'sweep' });
  mount(b, { mode: 'systems', labelEl: document.getElementById('featSysLabel') });
})();

/* ==========================================================================
   SCROLL HINT
   The comparison tables are wider than a phone. Flag that on the section when a pane actually
   overflows, which reveals the "swipe" note above the table.
   ========================================================================== */
(function () {
  'use strict';
  var panes = [].slice.call(document.querySelectorAll('.cmp-wrap, .vswrap'));
  if (!panes.length) return;
  panes.forEach(function (pane) {
    var sec = pane.closest('section');
    if (!sec) return;
    var sync = function () { sec.classList.toggle('is-scrollable', pane.scrollWidth - pane.clientWidth > 4); };
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) {
      try {
        var ro = new ResizeObserver(sync);
        ro.observe(pane);
        if (pane.firstElementChild) ro.observe(pane.firstElementChild);
      } catch (e) {}
    }
    window.addEventListener('load', sync);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(sync).catch(function () {}); }
    sync();
  });
})();
